const cardData = [
    { image: "game-01.png", name: "zombie apocalypse" },
    { image: "game-02.png", name: "buffalo 777" },
    { image: "game-03.png", name: "fortune gods" },
    { image: "game-04.png", name: "president 45" },
    { image: "game-05.png", name: "lucky duck" },
    { image: "game-06.png", name: "classic 777" },
    { image: "game-07.png", name: "fruit frenzy" },
    { image: "game-08.png", name: "safari ride" },
    { image: "game-09.png", name: "world cup gold" },
    { image: "game-10.png", name: "roman empire" },
    { image: "game-11.png", name: "mexicana loteria" },
    { image: "game-12.png", name: "retro reels 5x win" },
    { image: "game-13.png", name: "ghosts n goblines" },
    { image: "game-14.png", name: "prince of persia" },
    { image: "game-15.png", name: "st. patrick gold" },
    { image: "game-16.png", name: "pirate" },
    { image: "game-17.png", name: "wild jokers" },
    { image: "game-18.png", name: "feast hunter" },
    { image: "game-19.png", name: "jack o lantern" },
    { image: "game-20.png", name: "gold 777" },
    { image: "game-21.png", name: "where's santa" },
    { image: "game-22.png", name: "diamonds & riches" },
    { image: "game-23.png", name: "thribe of zeus" },
    { image: "game-24.png", name: "crazy birds" },
    { image: "game-25.png", name: "holiday party" },
    { image: "game-26.png", name: "sizzling 7's" },
    { image: "game-27.png", name: "gemstone galore" },
    { image: "game-28.png", name: "sirius stars" },
    { image: "game-29.png", name: "chinese new year" },
];

export { cardData };
